
import { PdfViewerComponent } from '@syncfusion/ej2-react-pdfviewer';


export function PdfViewerSync(source: PdfViewerComponent, target: PdfViewerComponent): PdfViewerSyncModel {

    var scrollEventHandler = (e: any) => {
        var targetObj: Element = document.querySelector("#" + target.element.id + " .e-pv-viewer-container");

        if (Math.round(targetObj.scrollTop) != Math.round(e.target.scrollTop)) {
            targetObj.scrollTop = e.target.scrollTop;
        }

        if (Math.round(targetObj.scrollLeft) != Math.round(e.target.scrollLeft)) {
            targetObj.scrollLeft = e.target.scrollLeft;
        }

        target.magnificationModule.zoomTo(source.zoomValue);
    };

    let pageEventHandler = (e: any) => {
        if (e.currentPageNumber != target.currentPageNumber)
            target.currentPageNumber = e.currentPageNumber;
    }

    let zoomEventHandler = (e: any) => {
        if (e.zoomValue != target.zoomValue)
            target.magnificationModule.zoomTo(e.zoomValue);
    };

    let sourceObj: Element = null;
    var res = {
        AddHandlers: () => {
            sourceObj = document.querySelector("#" + source.element.id + " .e-pv-viewer-container");

            sourceObj.addEventListener('scroll', scrollEventHandler);
            source.addEventListener('zoomChange', zoomEventHandler);
            source.addEventListener('pageChange', pageEventHandler)
        },
        RemoveHandlers: () => {
            //var sourceObj = $("#" + source.element.id + " .e-pv-viewer-container");
            sourceObj.removeEventListener('scroll', scrollEventHandler);
            source.removeEventListener('zoomChange', zoomEventHandler);
            source.removeEventListener('pageChange', pageEventHandler)
        }

    };
    return res;
}

export interface PdfViewerSyncModel {
    AddHandlers: () => void,
    RemoveHandlers: () => void

}